import { useEffect, useState } from "react";
import { Star, X, Calendar } from "lucide-react";
import api from "../lib/api";
import MarkdownArticle from "../components/tavern/MarkdownArticle";

const HERO = "https://images.unsplash.com/photo-1737317311906-67e5db95ad76?w=1600";

export default function StarCharts() {
  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(null);

  useEffect(() => {
    api.get("/posts", {params:{category:"star-charts"}}).then(r => setPosts(r.data)).catch(()=>{});
  }, []);

  return (
    <div className="page-container fade-in" data-testid="star-charts-page">
      <div className="relative overflow-hidden parchment-card p-8 md:p-12 mb-10">
        <img src={HERO} alt="celestial map" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="relative">
          <div className="page-eyebrow">the curiosity cabinet</div>
          <h1 className="page-title">Star Charts</h1>
          <p className="page-sub mt-3">
            A magical library and observatory in one room — folklore, history, science, museums, astronomy,
            travel ideas and the occasional research note pinned with a brass star.
          </p>
        </div>
      </div>

      <div className="bento-grid">
        {posts.map(p => (
          <article key={p.id} className="room-card overflow-hidden cursor-pointer" onClick={() => setOpen(p)} data-testid={`star-post-${p.id}`}>
            {p.image_url && <img src={p.image_url} alt={p.title} className="w-full aspect-[4/3] object-cover"/>}
            <div className="p-5">
              <div className="flex items-center gap-2 text-xs">
                <Star className="h-3 w-3" style={{color:"var(--gold)"}}/>
                <span className="page-eyebrow" style={{fontSize:"0.65rem"}}>{(p.tags||[]).slice(0,2).join(" · ") || "wonder"}</span>
              </div>
              <h3 className="tavern-heading text-xl gold-text mt-2">{p.title}</h3>
              <p className="text-sm mt-2" style={{color:"var(--muted)"}}>{p.excerpt}</p>
              <div className="tavern-script text-lg mt-3" style={{color:"var(--orchid-light)"}}>read this entry →</div>
            </div>
          </article>
        ))}
        {!posts.length && (
          <div className="col-span-full text-center" style={{color:"var(--muted)"}}>The shelves are being dusted…</div>
        )}
      </div>

      {open && (
        <div className="fixed inset-0 z-50 grid place-items-center p-4" style={{background:"rgba(0,0,0,0.7)"}} onClick={()=>setOpen(null)} data-testid="post-modal">
          <div className="parchment-card max-w-3xl w-full max-h-[85vh] overflow-auto p-7 md:p-10" onClick={e => e.stopPropagation()}>
            <button className="absolute top-3 right-3 p-2" onClick={() => setOpen(null)} aria-label="Close" data-testid="post-modal-close"><X style={{color:"var(--gold)"}}/></button>
            {open.image_url && <img src={open.image_url} alt={open.title} className="w-full max-h-[300px] object-cover rounded-sm mb-5"/>}
            <div className="page-eyebrow">{(open.tags||[]).join(" · ")}</div>
            <h2 className="tavern-heading text-3xl gold-text mt-2">{open.title}</h2>
            <p className="tavern-script text-xl mt-2" style={{color:"var(--orchid-light)"}}>{open.excerpt}</p>
            <div className="flex items-center gap-1 text-xs mt-2" style={{color:"var(--muted)"}}>
              <Calendar className="h-3 w-3" /> {new Date(open.created_at).toLocaleDateString(undefined,{year:"numeric",month:"short",day:"numeric"})}
            </div>
            <div className="gold-rule my-4"/>
            <MarkdownArticle className="prose-wide">{open.body}</MarkdownArticle>
          </div>
        </div>
      )}
    </div>
  );
}
